import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#f3f4f6",
        py: 2,
        paddingLeft: "10%",
        textAlign: "center",
        mt: "auto", // Ensures the footer is pushed to the bottom
      }}
    >
      {/* <Typography variant="body2" color="textSecondary">
        <Link href="/privacy-policy" underline="hover" sx={{ mr: 1 }}>
          Privacy Policy
        </Link>
        |
        <Link href="/contact-us" underline="hover" sx={{ ml: 1 }}>
          Contact Us
        </Link>
      </Typography> */}
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        &copy; {new Date().getFullYear()} by Shrood BI
      </Typography>
    </Box>
  );
};

export default Footer;
